import { render, staticRenderFns } from "./huis_hnlp.vue?vue&type=template&id=005b1b1c&scoped=true"
import script from "./huis_hnlp.vue?vue&type=script&lang=js"
export * from "./huis_hnlp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005b1b1c",
  null
  
)

export default component.exports